import { FC } from 'react';

interface AuthFormHeaderProps {
  preserveFormData?: boolean;
  view?: string;
  isEnterprise?: boolean;
}

export const AuthFormHeader: FC<AuthFormHeaderProps> = ({ preserveFormData, view, isEnterprise }) => {
  const getTitle = () => {
    if (preserveFormData) {
      return "Save Your Progress";
    }
    if (isEnterprise && view === 'sign_up') {
      return "Start Your Enterprise Trial";
    }
    return view === 'sign_up'
      ? "Create an Account to Begin Your Journey"
      : "Welcome Back";
  };

  const getDescription = () => {
    if (preserveFormData) {
      return "Create an account or sign in to save your eligibility assessment results";
    }
    if (isEnterprise && view === 'sign_up') {
      return "Create your enterprise account to access all features";
    }
    return view === 'sign_up'
      ? "Sign up to start exploring visa pathways"
      : "Sign in to continue your journey";
  };

  return (
    <div className="text-center space-y-4">
      <img src="/navisa-logo.svg" alt="Navisa" className="h-12 mx-auto" />
      <h2 className="text-3xl font-bold text-primary">
        {getTitle()}
      </h2>
      <p className="text-muted">
        {getDescription()}
      </p>
    </div>
  );
};